// extracted by mini-css-extract-plugin
module.exports = {"TagLink":"styles_TagLink__pBNVo"};